import React from 'react';

interface SwitchProps
{
	defaultChecked?: boolean;
	visible?: boolean;
	enabled?: boolean;
	onValueChanged?: (checked: boolean) => void;
}

export class Switch extends React.Component<SwitchProps, {}>
{
	public static defaultProps: Partial<SwitchProps> = {
		defaultChecked: false,
		visible: true,
		enabled: true,
		onValueChanged: undefined
	};

	constructor(props: SwitchProps)
	{
		super(props);
		this.onValueChanged = this.onValueChanged.bind(this);
	}

	private onValueChanged(event: React.ChangeEvent<HTMLInputElement>)
	{
		if (this.props.onValueChanged !== undefined)
		{
			this.props.onValueChanged(event.target.checked);
		}
	}

	public componentDidMount()
	{

	}

	public componentWillUnmount()
	{

	}

	public render()
	{
		return (
			this.props.visible &&
			<label className='switch' >
				<input
					type='checkbox'
					disabled={!this.props.enabled}
					defaultChecked={this.props.defaultChecked}
					onChange={this.onValueChanged}
				/>
				<span className='switch-slider' />
			</label>
		);
	}
}